import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { ApiService } from 'app/servicesTwo/ApiService';
import { Box, Card, CardContent, CircularProgress, Typography, Avatar, Container } from '@mui/material';
import Div from '@jumbo/shared/Div';
import PersonIcon from '@mui/icons-material/Person';
import Logo from 'app/shared/Logo';

const VolunteerPublicProfile = () => {
    const { id } = useParams();
    const [volunteer, setVolunteer] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchVolunteer = async () => {
            try {
                const response = await ApiService.get(`/public/volu-badge/info/${parseInt(id)}`);
                setVolunteer(response.data);
            } catch (err) {
                console.error(err);
                setError('Voluntário não encontrado ou erro ao buscar informações.');
            } finally {
                setLoading(false);
            }
        };

        if (id) {
            fetchVolunteer();
        }
    }, [id]);

    if (loading) {
        return (
            <Div sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                <CircularProgress />
            </Div>
        );
    }

    if (error) {
        return (
            <Container maxWidth="sm" sx={{ mt: 4, textAlign: 'center' }}>
                <Typography variant="h5" color="error">{error}</Typography>
            </Container>
        );
    }

    return (
        <Box sx={{ 
            minHeight: '100vh', 
            display: 'flex', 
            flexDirection: 'column', 
            alignItems: 'center', 
            bgcolor: '#ffffff',
            p: 0,
        }}>
            <Box sx={{ mt: 5 }}>
                <Logo />
            </Box>
            
            <Box sx={{ 
                flex: 1,
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'center',
                width: '100%',
                pb: 10
            }}>
                <Card sx={{ width: '100%', maxWidth: 600, borderRadius: 2, boxShadow: 'none', border: 'none' }}>
                    <CardContent sx={{ textAlign: 'center', p: 4 }}>
                        <Avatar
                            src={volunteer?.foto_cracha ? `${process.env.REACT_APP_API_KEY}/images/${volunteer.foto_cracha}` : ''}
                            sx={{ width: 120, height: 120, margin: '0 auto 20px', bgcolor: 'primary.main' }}
                        >
                            {!volunteer?.foto_cracha && <PersonIcon sx={{ fontSize: 60 }} />}
                        </Avatar>
                        
                        <Typography variant="h3" component="div" gutterBottom sx={{ fontWeight: 'bold' }}>
                            {volunteer?.nome_completo}
                        </Typography>

                        <Box sx={{ mt: 3, textAlign: 'center' }}>
                             <Typography variant="h4" color="text.primary" gutterBottom>
                                <strong>CPF:</strong> {volunteer?.cpf || 'Não informado'}
                            </Typography>
                            <Typography variant="h4" color="text.primary">
                                <strong>Idade:</strong> {volunteer?.idade ? `${volunteer.idade} anos` : 'Não informada'}
                            </Typography>
                        </Box>
                    </CardContent>
                </Card>
            </Box>
        </Box>
    );
};

export default VolunteerPublicProfile;
